import { API_URL } from '../../../config'
import store from '../../store'

export default {
  namespaced: true,

  actions: {
    async getTiposFormularios() {
      const response = await fetch(`${API_URL}/forms-patentamiento/tipos`, {
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        }
      })
      return response.json()
    },

    async getInfoUsado({}, payload) {
      const response = await fetch(`${API_URL}/forms-patentamiento/usado`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })
      return response.json()
    }
  }
}
